<template>
  <yd-dialog :title="''" :visible.sync="visible" :width="'70%'" append-to-body>
    <div class="page-title" slot="title" name="title">
      <div class="line" :class="[markerInfo.lineName ? 'margin-right-10' : '']">
        {{ markerInfo.lineName }}
      </div>
      <div v-if="markerInfo.stationName">{{ markerInfo.stationName }}-</div>
      <div>{{ markerInfo.name }}（{{ markerInfo.longitude }}, {{ markerInfo.latitude }}） </div>
    </div>

    <div class="map-box">
      <div class="amapContainer"></div>
    </div>
  </yd-dialog>
</template>

<!--
    使用示例：
    <yd-map-location v-model="show" :markerInfo="markerInfo" />
    
    const show = ref(false)
    const markerInfo = ref({
        latitude: '25.010054',
        longitude: '102.690357',
        name: '福海街道福泰路27号福源小区',
        lineName: '昆明-曲靖'
    })
    const handleClick = () => {
        show.value = true
    }
-->

<script >
import { watch, computed, onBeforeUnmount, nextTick } from '@vue/composition-api';
import { debounce } from 'lodash-es';
const __sfc_main = {};
__sfc_main.props = {
  // 地图中心点
  markerInfo: {
    type: Object,
    dafault: () => {}
  },
  title: {
    type: String,
    default: () => '位置详情'
  },
  value: {
    type: Boolean,
    default: () => false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emits = __ctx.emit;
  const visible = computed({
    get() {
      return props.value;
    },
    set(val) {
      emits('input', val);
    }
  });
  const AMap = window.AMap;
  // 地图实例
  let map = null;
  // 信息窗体
  const infoWindow = new AMap.InfoWindow({
    content: '',
    offset: new AMap.Pixel(-2, -34)
  });

  // 添加标注
  const addMarker = arr => {
    if (Array.isArray(arr) && arr.length > 0) {
      map && map.add(arr);
    }
  };

  // 清空标注
  const clearMarker = marker => {
    if (marker) {
      map && map.remove(marker);
    } else {
      map && map.clearMap();
    }
  };

  // 生成信息窗体内容
  const createInfoWindowContent = param => {
    const {
      longitude,
      latitude,
      name
    } = param || {};
    const content = `<div class="amap-info-content-inner">
                          <div>
                            <span>经纬度：</span>
                            <span style="color:#666666;">${longitude},${latitude}</span>
                          </div>
                          <div style="margin-top:10px;">
                            <span>地址：</span>
                            <span style="color:#666666;">${name}</span>
                          </div>
                      </div>`;
    infoWindow.setContent(content);
  };

  // 标注点击事件
  const handleClickMarker = (e, param) => {
    createInfoWindowContent(param);
    map && infoWindow.open(map, e.target.getPosition());
  };

  // 创建标注
  const createMarker = param => {
    const {
      longitude,
      latitude
    } = param || {};
    const marker = new AMap.Marker({
      icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
      position: [longitude, latitude],
      offset: new AMap.Pixel(-13, -30)
    });
    marker.on('click', e => {
      handleClickMarker(e, param);
    });

    // 打开信息窗体
    createInfoWindowContent(param);
    map && infoWindow.open(map, marker.getPosition());
    return marker;
  };
  const handleMarker = () => {
    const {
      longitude,
      latitude
    } = props.markerInfo || {};
    if (longitude && latitude) {
      setMapCenter({
        longitude,
        latitude
      });
      clearMarker();
      const marker = createMarker(props.markerInfo);
      addMarker([marker]);
    }
  };

  // 视野范围发生变化
  const regionchange = debounce(() => {
    handleMarker();
  }, 1000);

  // 绑定地图事件
  const addMapEvent = () => {
    // 绑定地图缩放事件
    map.on('zoomend', regionchange);
  };

  // 加载地图插件
  const addMapPlugin = () => {
    map.plugin(['AMap.ControlBar'], () => {
      // 缩放控件
      const controlBar = new AMap.ControlBar({
        position: {
          bottom: '-40px',
          right: '12px'
        }
      });
      map.addControl(controlBar);
    });
  };

  /**
   * 初始化地图
   * @param {*} params
   */
  const initAmap = params => {
    const {
      lng,
      lat
    } = params || {};
    let mapInitOptions = {
      zoom: 14,
      zooms: [6, 20],
      pitch: 80,
      rotation: 0,
      rotateEnable: true,
      // 地图是否可旋转
      resizeEnable: true,
      // 是否监控地图容器尺寸变化
      buildingAnimation: false,
      // 楼块出现是否带动画
      mapStyle: 'amap://styles/whitesmoke'
    };
    if (lng && lat) {
      mapInitOptions = {
        // 在初始化地图时，如果center属性缺省，地图默认定位到用户所在城市的中心
        center: [lng, lat],
        ...mapInitOptions
      };
    }
    const domArr = document.querySelectorAll('.amapContainer');
    map = new AMap.Map(domArr[domArr.length - 1], mapInitOptions);
    addMapPlugin();
    addMapEvent();
  };
  onBeforeUnmount(() => {
    map && map.destroy();
    map = null;
  });

  // 将经纬度移动到地图中心
  const setMapCenter = params => {
    const {
      longitude,
      latitude
    } = params || {};
    if (longitude && latitude) {
      map && map.setCenter([longitude, latitude]);
    }
  };
  watch([() => props.value, () => props.markerInfo], ([v, v1]) => {
    if (!v) {
      return;
    }
    if (!map) {
      nextTick(() => {
        // 云滴总部
        initAmap({
          lng: '102.7190744357639',
          lat: '25.01147433810764'
        });
      });
    }
    if (v1) {
      nextTick(() => {
        handleMarker();
      });
    } else {
      clearMarker();
    }
  }, {
    immediate: true,
    deep: true
  });
  return {
    visible
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .page-title {
    display: flex;
    align-items: flex-end;
    font-size: 18px;
    background-color: #ffffff;
    .line {
      font-size: 22px;
    }
  }

  .map-box {
    position: relative;
    width: 100%;
    height: 65vh;
  }
  .amapContainer {
    position: relative;
    width: 100%;
    height: 100%;
  }
  ::v-deep .el-dialog__body {
    padding-top: 10px;
  }
  ::v-deep .amap-info-content {
    border-radius: 8px;
    padding: 16px;
  }
  ::v-deep .amap-info-close {
    top: 10px;
    right: 10px !important;
    width: 18px;
    height: 18px;
    font: 400 24px / 14px Tahoma, Verdana, sans-serif;
    coloe: #666;
  }
</style>
<style>
  .amap-info-content-inner {
    padding-top: 15px;
    font-size: 14px;
    color: #333;
    word-break: break-all;
  }
  .amap-luopan {
    display: none;
  }
</style>
